import React from "react";

// Components
import Badge from "@vahak/core-ui/dist/components/Badge";

// Constants
import { LORRY_STATUS, LORRY_STATUS_TEXT } from "@vahak/core/dist/constants/lorryStatus";

interface LorryBadgeControllerProps {
    status?: LORRY_STATUS;
    outlined?: boolean;
    verificationPending?: boolean;
}

const LorryBadgeController = ({ status, outlined, verificationPending }: LorryBadgeControllerProps) => {
    const renderBadge = () => {
        switch (status) {
            case LORRY_STATUS.STAND_BY:
            case LORRY_STATUS.ACTIVE: {
                return (
                    <Badge
                        type="active"
                        text={LORRY_STATUS_TEXT.ACTIVE}
                        fillType={outlined ? "grey-outline" : "contained"}
                        showDot
                    />
                );
            }

            case LORRY_STATUS.IN_TRANSIT: {
                return (
                    <Badge
                        type="progress"
                        text={LORRY_STATUS_TEXT.IN_TRANSIT}
                        fillType={outlined ? "grey-outline" : "contained"}
                        showDot
                    />
                );
            }

            case LORRY_STATUS.VERIFICATION_FAILED: {
                return verificationPending ? (
                    <Badge
                        type="progress"
                        text="Verification pending"
                        fillType={outlined ? "grey-outline" : "contained"}
                        showDot
                    />
                ) : (
                    <Badge
                        type="warning"
                        text={LORRY_STATUS_TEXT.VERIFICATION_FAILED}
                        fillType={outlined ? "grey-outline" : "contained"}
                        showDot
                    />
                );
            }

            case LORRY_STATUS.IN_ACTIVE: {
                return (
                    <Badge
                        type="default"
                        text={LORRY_STATUS_TEXT.IN_ACTIVE}
                        fillType={outlined ? "grey-outline" : "contained"}
                        showDot
                    />
                );
            }
            default:
                return null;
        }
    };

    return renderBadge();
};

export default LorryBadgeController;
